/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IFilas from 'Infotrack@Modelos/smartStock/filas/entidades/filas';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import FilasCM from '../controladorModelo/filasCM';
import { IFormularioFilasCVProps } from '../interfaces';
import { acciones, IEstadoFilas } from '../reductorFilas';
import FormularioFilasVista from '../vista/formularioFilasVista';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import { useSelector } from 'react-redux';

const estadoInicial: IFilas = {
    EmpresaId: '',
    DescripcionFila: '',
    Estado: 1,
    AgenciaId: '',
};
const filasCM = new FilasCM();

const FormularioFilasCV: React.FunctionComponent<IFormularioFilasCVProps> = ({ IdEmpresa }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadFilas }, dispatch] = useProveedor<IEstadoFilas>();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IFilas>(estadoInicial);

    React.useEffect(() => {
        if (entidadFilas && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadFilas);
        } else {
            reiniciar();
        }
    }, [entidadFilas]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionFilas = () => {
        if (filasCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarFilas,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarFilas = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            filasCM
                .crearFilas({
                    ...valor,
                    EmpresaId: IdEmpresa,
                    AgenciaId: idAgencia,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            filasCM
                .editarFilas({
                    ...valor,
                    EmpresaId: IdEmpresa,
                    AgenciaId: idAgencia,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioFilasVista
            accionCrearEditar={confirmarCreacionEdicionFilas}
            cambiarInfoFomulario={alCambiarValor}
            filas={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion },
}: IEstadoGlobal): IFormularioFilasCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
});

export default connect<IFormularioFilasCVProps, null, any, IEstadoGlobal>(estadoAPropiedades, null)(FormularioFilasCV);
